<template>
  <!-- Панель проекции (elType === 1 это BaseItemTypes.PROJECTION). Раньше показ был
       зашит под клиентские Src/Dest-комбинации. Теперь показываем то, что реально
       пришло с бэка: цепочку и/или фильтр ролей, каждую часть по наличию данных. -->
  <div v-if="element && element.elType === 1">
    <div v-if="parentChain && parentChain.length" class="q-py-xs text-bold">
      {{ $t('projection_parents') }}
    </div>
    <div v-if="parentChain && parentChain.length">
      <div v-for="(p_item, p_index) in parentChain" :key="p_index">
        {{ p_item.Name }}
      </div>
    </div>

    <!-- Фильтр ролей показываем, только если роли пришли с бэка, иначе не висит
         пустой заголовок с пустым селектом. -->
    <template v-if="theModel && theModel.Roles && theModel.Roles.length">
      <div class="q-py-xs text-bold">
        {{ $t('projection_dest') }}
      </div>
      <q-select
        flat
        v-model="rolesModel"
        class="no-select-border q-mb-xs"
        hide-bottom-space
        fill-input
        option-label="Name"
        option-value="Id"
        multiple
        :label-slot="false"
        :bottom-slots="false"
        dense outlined
        input-debounce="500"
        label=""
        ref="roles_select"
        :hide-dropdown-icon="true"
        :options="theModel.Roles"
      >
        <template v-slot:no-option>
          <q-item>
            <q-item-section class="text-grey">
              {{ $t('no_data_found') }}
            </q-item-section>
          </q-item>
        </template>
      </q-select>
    </template>
  </div>
</template>

<script lang="ts">
import { Component, Emit, Prop, Vue, Watch } from 'vue-facing-decorator';
import { ProjectionParentInChain } from '@/models/interfaces/entity-settings';
import { settingsStore } from '@/store/settings';
import { BaseListItem } from '../base-list/interfaces/ListTypes';
import { AnalyticsElementOptionsDto } from '../../../models/interfaces/entity-settings/filters/filters';
import { ProjectionRolesFilterGroupDto } from '../../../models/interfaces/entity-settings/filters/group-filters';

@Component({
  name: 'ProjectionSettingsPanel'
})
export default class ProjectionSettingsPanel extends Vue {
  // v-model
  @Prop({ default: {} as ProjectionRolesFilterGroupDto })
  modelValue: any | undefined
  @Prop({ default: {} as ProjectionParentInChain })
  parentChain: ProjectionParentInChain | undefined
  @Prop({ default: {} as AnalyticsElementOptionsDto[] })
  optionsModelValue: AnalyticsElementOptionsDto[] | undefined
  @Prop({ default: {} as BaseListItem })
  element: BaseListItem | undefined
  @Emit("update:modelValue") emitModelValue(arg: any ) { return arg; }
  @Emit("update:optionsModelValue") emitOptions(arg: any) { return arg; }

  setstore: any | undefined = undefined

  created() {
    this.setstore = settingsStore()
  }

  get theModel() {
    return this.modelValue
  }

  set theModel(arg: any) {
    this.emitModelValue(arg)
  }

  get optionsModel() {
    return this.optionsModelValue
  }

  set optionsModel(arg: any) {
    this.emitOptions(arg)
  }
  
  // filter roles model
  get rolesModel(): any[] {
    if (!this.theModel) return []
    return this.theModel.Roles?.filter((el: any) => el.Selected)
  }

  set rolesModel(val: any[]) {
    if (!this.theModel) return

    const theonly_index = (val as any[]).findIndex(el => el.TheOnlyOption);
    let val_filtered: any[] = []
    if (theonly_index > -1) {
      // toggle
      if (theonly_index > -1 && this.rolesModel
      .findIndex((m: any) => m.Id === val[theonly_index].Id) > -1) {
        val_filtered = val
        val_filtered.splice(theonly_index, 1)
      } else {
        val_filtered = [val[theonly_index]]
      }
    } else {
      val_filtered = val
    }

    this.theModel.Roles = [ ...this.theModel.Roles.map((el: any) => {
      return {
        ...el,
        Selected: val_filtered.findIndex((v: any) => v.Id === el.Id) > -1
      }
    }) ]
  }
}
</script>

<style lang="scss">
</style>